import { Module } from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { ICMS, IRoot } from '@/interfaces';
import getInitialState from './initialState';

const state = getInitialState();
const namespaced: boolean = true;

export const cms: Module<ICMS, IRoot> = {
	namespaced,
	state,
	actions,
	getters,
	mutations,
};

export default cms;
